import { Injectable } from '@angular/core';
import { ViewModel } from '@farris/devkit';
import { FilterConditionService } from '../filter-condition.service';
import { CommandService } from '../command-service';

@Injectable()
class FilterConditionDataService {
    constructor(
        private viewModel: ViewModel,
        private filterConditionService: FilterConditionService,
        private commandService: CommandService
    ) { }

    /**
     * æ§è¡è¿æ»¤
     * @param commandName å½ä»¤åç§°
     * @param frameId å½ä»¤æå¨çframeId
     */
    public filter(commandName: string, frameId: string) {
        const self: any = this;
        let filters = self.context && self.context.eventParam && self.context.eventParam.data || [];
        if (typeof (filters) === 'string') {
            filters = JSON.parse(filters);
        }
        // æ¥è¯¢æ¶éç½®é¡µç ä¸ºç¬¬ä¸é¡µ
        this.viewModel.frameContext.repository.entityCollection.pageIndex = 1;
        this.viewModel.frameContext.repository.filterConditionManager.setConditions(this.viewModel.bindingPath, filters);
        return this.commandService.execute(commandName, frameId);
    }
}
export { FilterConditionDataService };
